<template>
  <portal to="modals">
    <modal :show="show" @close="$emit('hide', true)" title="Assume account" class="no-overflow">
      <card-minimal :class="`assume-account ${collapse ? 'collapse' : ''}`" v-click-outside="outsideClick">
        <form class="p-a-4" ref="form" @keyup.enter.stop="assumeAccount" tabindex="0">
          <form-dropdown tabindex="0" ref="dropdown" :search="true" :searchString="accountSearch" @search="changeSearchString" :maxHeight="250" @dropped="preventOutside = $event" :items="accounts.filter(a => a.id !== user.account_id).map(({ id, name }) => ({ value: id, string: name, selected: accountToAssume === id }))" @input="accountToAssumeFunc" placeholder="Choose account" class="dropdowner" />
          <div class="d-f fd-c ai-c jc-c">
            <Button class="large m-t-4" tabindex="0" @keyup.enter.stop="assumeAccount" @click.prevent="assumeAccount">Assume</Button>
          </div>
        </form>
      </card-minimal>
    </modal>
  </portal>
</template>

<script>

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * Return the current list of permissions
     * @return {?Array}
     */
    permissions() {
      return this.$store.getters['AccountManager/permissions'];
    },
    /**
     * Return a readable list for the Dropdown component of permissions
     * @return {?Array}
     */
    permissionList() {
      const {
        permissions,
        permissionToAssume,
      } = this;
      if (!permissions) return [];
      return permissions.map(permission => ({
        string: permission.name,
        value: permission.id,
        selected: permission.id === permissionToAssume,
      }));
    },
  },
  methods: {
    changeSearchString(searchString) {
      this.accountSearch = searchString;
      clearTimeout(this.accountTimeout);
      this.accountTimeout = setTimeout(() => {
        this.getAccounts();
      }, 250);
    },
    accountToAssumeFunc(event) {
      this.accountToAssume = event.value;
      this.$nextTick(() => {
        clearTimeout(this.outsideClickTimeout);
      });

      try {
        this.$refs.button.$el.focus();
      } catch (e) { /* Do nothing */ }
    },
    permissionToAssumeFunc(event) {
      this.permissionToAssume = event.value;
      this.$nextTick(() => {
        clearTimeout(this.outsideClickTimeout);
      });
    },
    outsideClick() {
      this.outsideClickTimeout = setTimeout(() => {
        if (this.preventOutside) {
          return;
        }
        this.$emit('outsideClick', true);
      }, 25);
    },
    /**
     * Assume account select via dropdown
     */
    async assumeAccount() {
      const {
        accountToAssume,
        assumed,
        permissionToAssume,
      } = this;

      if (!accountToAssume && !assumed) {
        return;
      }

      this.$emit('outsideClick', true);

      await this.$store.dispatch('AccountManager/assumeAccount', {
        account: accountToAssume || assumed,
        permission: permissionToAssume,
      });

      this.$nextTick(() => {
        this.changePermission = false;
        this.collapse = true;
        this.accountToAssume = null;
      });
    },
    async getAccounts() {
      const { accounts } = await this.$store.dispatch('AccountManager/getChildAccounts', {
        search: this.accountSearch,
        per_page: 50,
      });
      this.accounts = accounts;
    },
  },
  /**
   * Lets watch some things
   */
  watch: {
    permissionToAssume(val) {
      const {
        assumed,
      } = this;

      if (assumed && val) {
        this.assumeAccount();
      }
    },
    show(bool) {
      if (bool) {
        setTimeout(() => {
          try {
            this.$refs.dropdown.$el.querySelector('.inner').click();
          } catch (e) { /* Do nothing */ }
        }, 300);
      }
    },
  },
  data() {
    return {
      accounts: [],
      accountToAssume: null,
      permissionToAssume: null,
      accountSearch: '',
      changePermission: false,
      collapse: true,
      outsideClickTimeout: null,
      preventOutside: false,
      accountTimeout: false,
    };
  },
  async mounted() {
    if (this.user.account_id === 1) {
      this.accountSearch = 'test_%';
    }
    await this.getAccounts();
  },
};
</script>

<style lang="scss">
.card-minimal.assume-account {
  form {
    outline: none;
  }

  &.collapsee {
    .card-content {
      background-color: #0060FF;
      color: white;

      small {
        color: white;
      }
    }

    .assume-controls {
      display: none;
    }
  }

  &:not(.collapse) {
    width: 100%;
  }

  .assume-controls {
    flex-direction: column;

    & > * {
      margin-left: 0;
      &:not(:last-child) {
        margin-bottom: 5px;
      }
    }
  }

  .assumed-as {
    align-items: center;
    display: flex;
    cursor: pointer;
    user-select: none;

    small {
      color: black;
    }

    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      span {
        font-size: 12px;
        font-weight: 600;
      }

      strong {
        font-weight: 400;
      }
    }

    i {
      font-size: 20px;
    }
  }
}
</style>
